import { render, staticRenderFns } from "./tblCalculationCompConcLimits.vue?vue&type=template&id=136bb1a0&scoped=true"
import script from "./tblCalculationCompConcLimits.vue?vue&type=script&lang=js"
export * from "./tblCalculationCompConcLimits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136bb1a0",
  null
  
)

export default component.exports